'use client';

import React from 'react';
import { SUPPORTED_LANGUGES } from '@altus-ui/i18n';
import Select from '../components/Select';
import { KoreaIcon, UsaIcon } from './icons';

const LanguageSelector = (props: {
  currentLang: SUPPORTED_LANGUGES;
  onChange: (value: SUPPORTED_LANGUGES) => void;
  className?: string;
}) => {
  const { currentLang, onChange, className } = props;

  const langList = [
    {
      icon: () => <UsaIcon />,
      value: SUPPORTED_LANGUGES.EN_US,
      label: 'English'
    },
    {
      icon: () => <KoreaIcon />,
      value: SUPPORTED_LANGUGES.KO_KR,
      label: '한국어'
    }
  ];
  const handleChange = (value: SUPPORTED_LANGUGES) => {
    onChange?.(value);
  };

  return (
    <div className={className}>
      <Select
        options={langList}
        defaultValue={currentLang}
        onChange={handleChange}
      />
    </div>
  );
};

export default LanguageSelector;
